'use strict';

/* global coachingDrawer */

(function () {
  'use strict';

  angular.module('vnext').controller('VNextCtrl', VNextCtrl);

  VNextCtrl.$inject = ['$scope', '$rootScope', '$log', '$timeout', '$window', '$location', 'windowSvc', 'providerSvc', 'domainSvc', 'userSvc', 'NotifyingSvc', 'eventTrackingSvc', 'msAuth', 'referralSvc', '$document', 'focus', '$translate'];

  /* @ngInject */
  function VNextCtrl($scope, $rootScope, $log, $timeout, $window, $location, windowSvc, providerSvc, domainSvc, userSvc, NotifyingSvc, eventTrackingSvc, msAuth, referralSvc, $document, focus, $translate) {
    // NOSONAR

    var vm = this;
    vm.title = 'VNextCtrl';
    vm.shouldHideNotice = _shouldHideNotice;
    // Coaching related properties
    vm.showCoaching = false;
    vm.userHasCoaching = false;
    vm.coachingMessages = 0;
    vm.coachName = null;
    vm.coachProfileImage = null;
    vm.vueCoachingHasInit = false;
    vm.appMode = 'STANDARD';

    vm.coBrandingHeaderImage = null;

    // Rootscope properties
    $rootScope.showCoaching = false;
    $rootScope.isMobileWebView = false;
    $rootScope.telehealthTriggered = false;
    $rootScope.webViewPostMessages = {
      home: {
        path: 'home',
        parameters: {}
      },
      telehealth: {
        path: 'TELEHEALTH_GETHELP',
        parameters: {}
      }
    };
    // Referral properties
    vm.orgReferralSettings = [];

    // Send postMessage to mobile app webview
    $rootScope.sendWebViewPostMessage = function (postMessageKey) {
      var postMessagePayload = $rootScope.webViewPostMessages[postMessageKey] ? $rootScope.webViewPostMessages[postMessageKey] : null;

      // If path home AND telehealthTriggered
      // replace payload path with telehealth
      if (postMessagePayload && postMessagePayload.path === 'home' && $rootScope.telehealthTriggered === true) {
        postMessagePayload = $rootScope.webViewPostMessages.telehealth;
      }

      if ($rootScope.isMobileWebView && postMessagePayload) {
        // iOS
        try {
          window.webkit.messageHandlers.appInterface.postMessage(postMessagePayload, window.location.origin);
        } catch (error) {
          $log.debug('iOS postMessage error: ', error);
        }
        // Android
        try {
          window.appInterface.postMessage(JSON.stringify(postMessagePayload));
        } catch (error) {
          $log.debug('Android postMessage error: ', error);
        }
      }
    };

    $document.unbind('keyup.closeNav').bind('keyup.closeNav', function (e) {
      if (e.keyCode === 27) {
        vm.closeNav();
        $scope.$apply();
      }
    });

    vm.toggleNav = function () {
      vm.navOpen = !vm.navOpen;
      $rootScope.isMobileMenuOpen = !$rootScope.isMobileMenuOpen;
      if (vm.navOpen) {
        focus.byId('mainNav', 300);
      } else {
        focus.byId('open-menu', 300);
        vm.removeOpenSelectState();
      }
    };

    vm.closeNav = function () {
      focus.byId('open-menu', 300);
      vm.navOpen = false;
      $rootScope.isMobileMenuOpen = false;
      vm.removeOpenSelectState();
    };

    vm.removeOpenSelectState = function () {
      if ($rootScope.isSelectOpened) {
        delete $rootScope.isSelectOpened;
      }
    };

    vm.hasPermission = function (permission) {
      return vm.user && msAuth.hasPermission(permission);
    };

    vm.showPC = function () {
      return vm.user && (vm.hasPermission('ADMIN') || vm.user.accessCode.type === 'INTERNAL');
    };

    vm.showReferral = function () {
      return vm.user && (vm.hasPermission('ADMIN') || vm.user.accessCode.type === 'INTERNAL') && vm.referralUrl && vm.orgReferralSettings.length > 0;
    };

    vm.showDashboard = function () {
      return vm.hasPermission('CONSOLE') || vm.hasPermission('COACH');
    };

    vm.showProviderLinks = function () {
      return vm.showPC() || vm.showReferral() || vm.showDashboard();
    };

    vm.disableCoaching = function () {
      $scope.nav.showCoaching = false;
      vm.userHasCoaching = false;
    };

    vm.enableCoaching = function () {
      userSvc.getUser(true).then(function (u) {
        if (_.isUndefined(u)) {
          vm.userHasCoaching = false;
          return;
        }

        _setUICoachingEnablement(u);
      });
    };

    // Watch nav.showCoaching to sync with angular -> vue
    $scope.$watch('nav.showCoaching', function (newValue) {
      // Set rootscope showCoaching for body.disable-scroll ng-class usage
      $rootScope.showCoaching = newValue;

      if (newValue === true) {
        // Reset new message counts / badge
        vm.coachingMessages = 0;
      }

      // Angular -> Vue communication
      window.postMessage({
        name: 'showCoaching',
        origin: 'angular',
        value: newValue
      }, window.location.origin);
    });

    // Vue -> Angular communication
    window.addEventListener('message', function (e) {
      var messageData = e.data;

      // Prevent actions on any messages not from vue
      if (messageData.origin !== 'vue') {
        return;
      }

      if (messageData.name === 'showCoaching') {
        // Update angular value
        $scope.nav.showCoaching = messageData.value;
        $scope.$apply();
      }
      if (messageData.name === 'newCoachingMessage') {
        // Fetch user and update unread count
        userSvc.getUser(true).then(function (u) {
          vm.coachingMessages = u.coachingAssignment.unreadMessages;
        });
      }
    }, false);

    activate();

    // When the screen size reaches 'not handheld' size ($bp5 in _variables.scss),
    // set the sidebar nav to be open.
    // Similarly, when the screen size reaches 'handheld' sized,
    // close the sidebar nav.
    // When the sidebar nav is closed, 'msPreventFocusHere' prevents the user
    // from reaching those links with the [tab] key.
    // Setting it to open on desktop sized screens ensures desktop users can always reach it.
    var mobileMatch = $window.matchMedia('(min-width: 62em)');

    function mediaQueryChange(mediaQueryList) {
      if (mediaQueryList.matches) {
        $timeout(function () {
          vm.navOpen = true;
        });
      } else {
        $timeout(function () {
          vm.navOpen = false;
        });
      }
    }
    mediaQueryChange(mobileMatch);
    mobileMatch.addListener(mediaQueryChange);

    function activate() {
      _setUpGa();
      _setIsMobileWebView();

      vm.adminDomain = domainSvc.getAdminDomain();
      vm.baseDomain = domainSvc.getBaseDomain();
      if (msAuth.hasPermission('MFA_VERIFIED')) {
        vm.userDashboardLink = domainSvc.getUserDashboardDomain() + '/#/';
      } else {
        vm.userDashboardLink = domainSvc.getAppDomain() + '/login/authcode';
      }

      providerSvc.getCoBrandingHeaderImage().then(function (resp) {
        vm.coBrandingHeaderImage = resp;
      });

      userSvc.getUser(true).then(function (u) {
        if (_.isUndefined(u)) {
          vm.userHasCoaching = false;
          return;
        }

        vm.user = u;

        vm.appMode = vm.user && vm.user.accessCode && vm.user.accessCode.applicationMode ? vm.user.accessCode.applicationMode.name : 'STANDARD';

        _setUICoachingEnablement(u);
        _getOrgReferralSettings();
        _buildReferralUrl();
      });

      $rootScope.$on('$stateChangeStart', function () {
        if (!mobileMatch.matches) {
          vm.closeNav();
        }
      });

      vm.resetFocusSwitchedState = function () {
        delete $rootScope.hasFocusSwitched;
      };

      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.USER_UPDATED, function () {
        userSvc.getUser().then(function (u) {
          return vm.user = u;
        });
      });

      // Subscribe to USER_COACHING_ENABLEMENT_UPDATED event to enable or disable coaching without pageload
      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.USER_COACHING_ENABLEMENT_UPDATED, function (evt, data) {
        if (data.status) {
          vm.enableCoaching();
        } else {
          vm.disableCoaching();
        }
      });
    }

    function _setCoachingProperties(hasCoaching, userData, userCoachingProfile) {
      // Prevent setting of properties and vue init if user is not enrolled in coaching
      if (!hasCoaching) {
        return;
      }

      var coachingData = userData.coachingAssignment;

      vm.currentCoachName = coachingData.currentCoachName;
      vm.coachProfileImage = coachingData.profileImageUrl;
      vm.coachingMessages = coachingData.unreadMessages;

      // Init vuejs driven sidebar with global coachingDrawer
      // - global coachingDrawer needed due to angular bootstrap timing issues
      // - Vue html fragment in `app/components/vnext/pages/main-coaching-drawer-vue.pug`
      if (!vm.vueCoachingHasInit) {
        coachingDrawer.init(userData, userCoachingProfile);
        vm.vueCoachingHasInit = true;
      }

      // Open coaching if user has query string `?openCoaching`
      // - localStorage for persisting across route changes & page load
      if ($location.search().openCoaching || localStorage.getItem('openCoaching') === 'true') {
        $timeout(function () {
          $scope.nav.showCoaching = true;
          $location.search('openCoaching', null);
          localStorage.setItem('openCoaching', false);
        }, 1500);
      }
    }

    function _buildReferralUrl() {
      if (!vm.user) {
        return;
      }

      vm.referralUrl = '/referral/' + vm.user.organization.shortName;
      vm.referralUrl = vm.referralUrl + '?returnurl=' + windowSvc.getRedirectUrl();
    }

    function _getOrgReferralSettings() {
      if (!vm.user) {
        return;
      }

      referralSvc.getReferralOrgReferralSettings(vm.user.organization.shortName).then(function (resp) {
        vm.orgReferralSettings = resp;
      });
    }

    function _shouldHideNotice() {
      userSvc.savePreferences({
        hideMindfulBanner: 'true'
      }, function (updatedUser) {
        vm.user = updatedUser;
      });
    }

    function _setUpGa() {
      eventTrackingSvc.init();
      // send pageviews to google analytics
      eventTrackingSvc.registerEventListeners();
    }

    function _setIsMobileWebView() {
      var hasMobileJWT = msAuth.hasPermission('MOBILE');
      var queryParams = $location.search();

      if (queryParams.isMobileWebView || hasMobileJWT) {
        $rootScope.isMobileWebView = true;
      }
    }

    function _setUICoachingEnablement(u) {
      userSvc.getUsersCoachingProfile().then(function (resp) {
        var userCoachingProfile = resp;
        var coachingElectionStatus = !_.isUndefined(userCoachingProfile.coachingElection) ? userCoachingProfile.coachingElection : null;

        $translate.onReady(function () {
          // Enables coaching UI elements & controls the setting of coach related vm props
          vm.userHasCoaching = _detectUserHasCoaching(u, coachingElectionStatus); //
          // Set coaching related properties
          _setCoachingProperties(vm.userHasCoaching, u, userCoachingProfile);
        });
      });
    }

    function _detectUserHasCoaching(u, coachingElection) {
      return !$rootScope.isMobileWebView && !_.isUndefined(u.coachingAssignment) && u.coachingAssignment !== null && coachingElection !== null && coachingElection !== 'INELIGIBLE' && coachingElection !== 'OPTED_OUT';
    }
  }
})();